import type { BlockItem } from "../../types/block-item.types";
import * as inputExports from "./_index";

// Función para verificar si un objeto es un BlockItem

function isBlockItem(x: unknown): x is BlockItem {
    return (
        !!x &&
        typeof x === "object" &&
        "id" in x &&
        "label" in x &&
        "description" in x &&
        "group" in x &&
        "source" in x &&
        "content" in x
    );
}

//Exporta todos los bloques basicos

export const BASIC_INPUTS: readonly BlockItem[] = Object.values(inputExports).filter(isBlockItem).filter((b) => b.source === "basic" && b.group === "Inputs");
